<template>
  <div class="w-full mt-20 md:px-2" v-if="users">
    <pagination :data="users" route="admin.users"></pagination>

    <div class="flex mx-auto w-inherit pb-8">
      <user-admin-table :users="users.data" />
    </div>

    <pagination :data="users" route="admin.users"></pagination>

    <portal to="breadcrumb-portal">
      <breadcrumbs>
        <router-link class="breadcrumb-link" :to="{name: 'channels.index'}">Home</router-link>
        <chevron-right-icon class="mx-1"></chevron-right-icon>
        <router-link class="breadcrumb-link" :to="{name: 'admin'}">Admin</router-link>
        <chevron-right-icon class="mx-1"></chevron-right-icon>
        <span class="breadcrumb-current">Users</span>
      </breadcrumbs>
    </portal>
  </div>
</template>

<script>
import Pagination from "@/components/Pagination"
import UserAdminTable from "@/components/Tables/UserAdminTable"
import { EventBus } from "@/events"
import { ChevronRightIcon } from "vue-feather-icons"

export default {
  name: "Users",
  components: {
    Pagination,
    UserAdminTable,
    ChevronRightIcon
  },
  data() {
    return {
      loading: false,
      users: null
    }
  },
  watch: {
    $route: {
      handler() {
        if (this.$route.query.page !== null) this.page = this.$route.query.page
        this.fetch()
      },
      immediate: true
    }
  },
  methods: {
    async fetch() {
      this.loading = true
      await this.$api.users
        .get(this.page)
        .then(({ data }) => (this.users = data))
      this.loading = false
    }
  },
  mounted() {
    EventBus.$on("user:update", () => this.fetch())
  }
}
</script>

<style scoped lang="scss">
</style>
